import { convertResultDate } from '../../common/datePicker/helper'

export const covertTypeCategory = (data) => [
  {
    label: 'library.downloadedFiles.ALL',
    isI18n: true,
    value: null,
  },
  ...data?.map((item) => ({
    value: item?.fileCategoryId,
    label: item?.fileCategoryName,
  })),
]

export const getListIdTableDownload = (data) =>
  data.map((item) => item.downloadedFileId)

export const convertDataTableDownload = (data) => {
  const ids = getListIdTableDownload(data)
  const objData = {}

  ids.forEach((id) => {
    const dataRow = data.find((item) => item.downloadedFileId === id)
    objData[id] = {
      ...dataRow,
      downloadedFileId: {
        id: dataRow?.downloadedFileId,
        isExpired: dataRow?.isExpired,
        orderId: dataRow?.orderId,
        fileCategoryId: dataRow?.fileCategoryId,
      },
    }
  })
  return objData
}

export const getDataSizeTable = (data) => ({
  Page: data?.page,
  PageSize: data?.pageSize,
})

export const handleDateTo = (date, timezone) => {
  return convertResultDate(new Date(date), timezone, false)
}
